<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <!-- <bc-btn-add
                                v-if="hasPerm('work_orders_settings.create')"
                                @invoke-method="invokeMethod($event)"
                                action="showWorkOrdersSetting"
                            ></bc-btn-add> -->
                            <bc-scan-barcode
                                v-if="hasPerm('scheduling.update')"
                                ref="scan_barcode"
                                scan-object="work_orders_batch"
                                header-text="Batch Lookup"
                                @scanned="barcodeScanned($event)"
                                scan-label="i"
                                :global="true"
                            ></bc-scan-barcode>
                            <bc-btn-refresh @invoke-method="dbGetWorkOrdersSettings()" permanent></bc-btn-refresh>
                            <bc-btn-nonconformance
                                ref="nonconformance"
                                entity_object="work_orders_batch"
                                :entity_id="currObjField('batch_id')"
                                no-button
                            ></bc-btn-nonconformance>
                            <!-- <bc-search-menu
                                :params="axiosParams"

                            >
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input
                                            v-model="filter.search"
                                            :params="axiosParams"
                                        ></bc-search-input>
                                    </v-list-tile>

                                    <v-divider></v-divider>

                                </v-list>
                            </bc-search-menu> -->
                            <!-- <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobile_list"
                            ></bc-btn-mobile-nav> -->
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="{ 'px-0': $bp.smallScreen, 'prevent-click': !hasPerm('scheduling.update') }" v-if="(work_orders_batches || []).length > 0">
                    <v-card
                        color="grey lighten-4"
                        class="mb-3 clickable"
                        v-for="(batch, i) in work_orders_batches"
                        :key="i"
                        @click="showWorkOrdersSetting(batch)"
                    >
                        <v-card-title class="py-2 primary-light-hover">
                            <v-layout row wrap>
                                <v-flex xs12 sm3 column>
                                    <span class="headline">{{ batch.batch_control_id }}</span>
                                    <span class="fs-18">{{ batch.name }}</span>
                                    <span class="fs-12 pt-2">Begin setting by: {{ batch.set_date }}</span>
                                </v-flex>
                                <v-flex xs12 sm3 column align-self-start :class="$bp.xsOnly ? 'my-2' : 'text-center'">
                                    <span class="headline">{{ batch.batch_size }} Qty</span>
                                    <span class="fs-16" v-if="batch.jig_tag_number">Jig Tag #: {{ batch.jig_tag_number }}</span>
                                </v-flex>
                                <v-flex xs6 sm3 column order-xs2 order-sm1 align-self-start>
                                    <v-img :src="batch.photo" height="100px" width="100px" class="rounded-circle mx-auto" @error="showErrorImg = true"></v-img>
                                </v-flex>
                                <v-flex xs6 sm3 column text-right order-xs1 order-sm2 align-self-start my-auto>
                                    <v-layout row>
                                        <v-flex order-xs2 order-sm1 :class="$bp.xsOnly ? 'text-left' : 'text-right'">
                                            <span class="headline">{{ batch.setting_station ? batch.setting_station.people_started_by : "" }}</span>
                                            <span class="fs-12">{{ batch.setting_station ? `Started: ${batch.setting_station.date_begin}` : "" }}</span>
                                        </v-flex>
                                        <v-flex shrink mx-2 order-xs1 order-sm2 style="width: 50px">
                                            <v-avatar v-if="batch.setting_station">
                                                <img :src="batch.setting_station.photo" />
                                            </v-avatar>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-title>
                    </v-card>
                </v-card-text>
                <v-layout v-else>
                    <v-flex class="text-center align-content-center" :style="$bp.smallScreen ? 'margin-top:16px;' : 'height:calc(100vh - 300px)'">
                        <span class="blue-grey--text text--lighten-4 display-1">No available batches</span>
                    </v-flex>
                </v-layout>
            </v-card>

            <bc-dialog :value="work_orders_setting_dialog" max-width="800">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t("lang.setting") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeWorkOrdersSettingDialog"
                            :dialog-status="work_orders_setting_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="work_orders_setting" @submit.prevent>
                            <v-container grid-list-form>
                                <v-layout row wrap style="min-height: 350px">
                                    <v-flex xs12 sm7 align-self-start pa-0>
                                        <v-layout row wrap inner-layout>
                                            <v-flex xs12>
                                                <span class="fs-14">{{ $t("lang.part_name") }}</span>
                                                <h3>{{ currObjField("name") }}</h3>
                                            </v-flex>
                                            <v-flex xs12>
                                                <span class="fs-14">{{ $t("lang.customer_part_number") }}</span>
                                                <h3>{{ currObjField("customer_part_number") }}</h3>
                                            </v-flex>
                                            <v-flex xs12>
                                                <span class="fs-14">{{ $t("lang.company") }}</span>
                                                <h3>{{ currObjField("company") }}</h3>
                                            </v-flex>
                                            <v-flex xs12>
                                                <span class="fs-14">{{ $t("lang.control_id") }}</span>
                                                <h3>{{ currObjField("batch_control_id") }}</h3>
                                            </v-flex>
                                            <v-flex xs12 v-if="currObjField('setting_minutes_to_complete')">
                                                <span class="fs-14">{{ $t("lang.estimated_minutes_to_complete") }}</span>
                                                <h3>{{ currObjField("setting_minutes_to_complete") }}</h3>
                                            </v-flex>
                                            <v-flex xs12 sm10 v-if="currObjField('setting_station')">
                                                <v-text-field
                                                    v-focus="work_orders_setting_dialog"
                                                    v-model="work_orders_setting.jig_tag_number"
                                                    :label="`${$t('lang.jig_tag_number')} *`"
                                                    :counter="showCounter(work_orders_setting.jig_tag_number, 'work_orders_setting.jig_tag_number')"
                                                    :rules="ifValid('work_orders_setting.jig_tag_number')"
                                                    type="number"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm5 align-self-start pa-0>
                                        <v-img
                                            :src="currObjField('photo')"
                                            height="175px"
                                            width="175px"
                                            class="rounded-circle"
                                            :class="$bp.smAndUp ? 'mx-auto' : ''"
                                        ></v-img>
                                        <template v-if="currObjField('setting_station')">
                                            <span class="fs-18">{{ $t("lang.destination") }}</span>
                                            <span style="font-size: 100px; max-height: 90px; bottom: 30px; position: relative">{{
                                                currObjField("furnace")
                                            }}</span>
                                        </template>
                                    </v-flex>
                                    <template v-if="currObjField('setting_instructions')">
                                        <v-layout row wrap inner-layout px-2 :class="$bp.xsOnly ? 'pt-3' : ''">
                                            <v-flex xs12 font-italic pb-0>{{ $t("lang.instructions") }}</v-flex>
                                            <v-flex xs12 pt-0 style="max-height: 200px; overflow-y: auto">{{ currObjField("setting_instructions") }}</v-flex>
                                        </v-layout>
                                    </template>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeWorkOrdersSettingDialog()">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn
                            color="success"
                            @mouseup.left="
                                currObjField('setting_station')
                                    ? openNonconformanceAfter()
                                    : modifyWorkOrdersSetting('post', currObjField('batch_id'), currSettingStationField('work_order_setting_id'))
                            "
                            >{{ currObjField("setting_station") ? $t("lang.complete") : $t("lang.assign_to_me") }}</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="confirm_nonconformance_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t("lang.final_check") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="confirm_nonconformance_dialog"
                            :dialog-status="confirm_nonconformance_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <span class="fs-22">Do you need to report a nonconformance for this batch?</span>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            flat
                            @mouseup.left="modifyWorkOrdersSetting('patch', currObjField('batch_id'), currSettingStationField('work_order_setting_id'))"
                            >{{ $t("lang.no") }}</v-btn
                        >
                        <v-btn
                            color="success"
                            @mouseup.left="modifyWorkOrdersSetting('patch', currObjField('batch_id'), currSettingStationField('work_order_setting_id'), true)"
                        >
                            {{ $t("lang.yes") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            confirm_nonconformance_dialog: false,
            work_orders_setting: {
                batch_id: "",
                jig_tag_number: "",
            },
            current_obj: null,
            filter: {
                search: "",
                page_size: 0,
                page_num: 0,
            },
            work_orders_setting_dialog: false,
            // mobile_list: [
            //     { title: this.$t('lang.add_new'), action: "showWorkOrdersSetting" },
            //     { title: this.$t('lang.refresh'), action: "dbGetWorkOrdersSettings"}
            // ],
            dbGetWorkOrdersSettings: _.debounce(this.getWorkOrdersSettings, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchWorkOrder", {
                url: "work_orders/batch/setting",
                method: "get",
                stateProperty: "work_orders_batches",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.work_orders_batches) {
                    next((vm) => {
                        // vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchWorkOrder", {
                url: "work_orders/batch/setting",
                method: "get",
                stateProperty: "work_orders_batches",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.work_orders_batches) {
                    // this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_work_orders_setting: (state) => state.validation.rules_work_orders_setting,
            // default_filter: state => state.work_orders.work_orders_settings_filter,
            page: (state) => state.work_orders.page,
            work_orders_batches: (state) => state.work_orders.work_orders_batches,
        }),
        // axiosParams() {
        //     return this.prepareParams(this.filter, this.default_filter);
        // },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
        currSettingStationField() {
            return (field) => {
                return this.current_obj && this.current_obj.setting_station && field && this.current_obj.setting_station[field]
                    ? this.current_obj.setting_station[field]
                    : "";
            };
        },
    },
    methods: {
        closeWorkOrdersSettingDialog() {
            this.work_orders_setting_dialog = false;
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getWorkOrdersSettings() {
            this.startLoader();
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: "work_orders/batch/setting",
                    method: "get",
                    stateProperty: "work_orders_batches",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.work_orders_setting_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        modifyWorkOrdersSetting(method = null, batch_id = null, setting_id = null, start_nonconformance = false) {
            console.log(setting_id);
            if (method) {
                this.confirm_nonconformance_dialog = false;
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("work_orders_setting")) {
                        this.$store.commit("toggleModalLoader", true);
                        let batch_id_body = {
                            batch_id: batch_id,
                        };
                        this.$store
                            .dispatch("fetchWorkOrder", {
                                pk: "batch_id",
                                id: batch_id,
                                url: `work_orders/batch/setting${setting_id ? `/${setting_id}` : ""}`,
                                method: method,
                                stateProperty: "work_orders_batches",
                                commit: true,
                                body: method == "patch" ? this.work_orders_setting : batch_id_body,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeWorkOrdersSettingDialog();
                                    if (start_nonconformance) {
                                        this.$refs.nonconformance.showNonconformance();
                                    }
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showWorkOrdersSetting(item = null) {
            this.current_obj = item;

            if (this.$refs.work_orders_setting) item ? this.$refs.work_orders_setting.resetValidation() : this.$refs.work_orders_setting.reset();

            this.$nextTick(() => {
                this.assignObj(this.work_orders_setting, item, this.rules_work_orders_setting);
                this.work_orders_setting_dialog = true;
            });
        },
        openNonconformanceAfter() {
            this.$store.commit("validationOn");
            this.$nextTick(() => {
                if (this.validateForm("work_orders_setting")) {
                    this.confirm_nonconformance_dialog = true;
                }
            });
        },
        barcodeScanned(scan) {
            if (scan && !this.$refs.scan_barcode.barcode_dialog && !this.work_orders_setting_dialog) this.$refs.scan_barcode.barcode_dialog = true;
            let item = this.work_orders_batches.find((batch) => batch.batch_id == scan.batch_id);
            if (item) {
                this.showWorkOrdersSetting(item);
                this.$refs.scan_barcode.closeBarcode();
            } else {
                this.$refs.scan_barcode.resetBarcode(true);
            }
            this.$store.commit("toggleGlobalSnackbar", false);
        },
    },
};
</script>
